import { Component, OnInit } from '@angular/core';
import { ERROR_PROGRESS, FileDownload } from './service/FileDownload';
import { DownloadingService } from './service/downloading.service';

@Component({
  selector: 'app-downloading',
  template: `<div class="file-dialog-container">
    @for (file of files; track file) {
      <div class="alert-download alert alert-info">
        <div class="file-dialog-content">
          <div class="file-dialog-content-text">{{ getText(file) }}</div>
          @if (file.progress < 0) {
            <div class="file-dialog-loader-container">
              <app-lds-ring></app-lds-ring>
            </div>
          }
        </div>
        <div class="file-dialog-progress-container">
          @if (file.progress >= 0) {
            <div class="progress ">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated {{ getProgressType(file) }}"
                role="progressbar"
                [attr.aria-valuenow]="getValueNow(file)"
                aria-valuemin="0"
                aria-valuemax="100"
                [style.width.%]="getValueNow(file)"
              ></div>
            </div>
          }
        </div>
      </div>
    }
  </div>`,
  styleUrls: ['./downloading.component.scss'],
  standalone: false,
})
export class DownloadingComponent implements OnInit {
  files: FileDownload[] = [];

  constructor(private downloadService: DownloadingService) {}

  ngOnInit() {
    this.downloadService.getFiles().subscribe((file) => {
      const existingFile = this.files.find((f) => f.fileName === file.fileName);
      if (existingFile) {
        existingFile.progress = file.progress;
      } else {
        this.files.push(file);
      }
      if (file.progress === 100 || file.progress === ERROR_PROGRESS) {
        setTimeout(() => this.removeFile(file), 1000);
      }
    });
  }

  getProgressType({ progress }: FileDownload) {
    return progress < 0 ? 'bg-info' : 'bg-success';
  }

  getValueNow({ progress }: FileDownload) {
    return progress < 0 ? 100 : progress;
  }

  removeFile(file: FileDownload) {
    this.files = this.files.filter((x) => x.fileName !== file.fileName);
  }

  getText(file: FileDownload) {
    return file.progress < 0 ? `Generating file ${file.fileName}` : `Downloading ${file.fileName}: ${file.progress}%`;
  }
}
